import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import { firstPayTime } from "@/api/data";
export default {
  components: {
    DataOptions: DataOptions,
    serverList: serverList,
    VxeTable: VxeTable
  },
  data: function data() {
    return {
      tableData: [],
      timedata: [this.$moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      type: 0,
      options: [{
        label: "全部角色",
        value: 0
      }, {
        label: "新角色",
        value: 1
      }, {
        label: "滚服角色",
        value: 2
      }],
      searchInfo: {
        server_id: [],
        role_type: 0
      },
      tableColumn: [{
        field: "roleFirstPayTime",
        title: "角色首次付费时间",
        sortable: true
      }, {
        field: "cnt",
        title: "人数",
        sortable: true
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.timedata[0];
              _this.searchInfo.edate = _this.timedata[1];
              _context.next = 4;
              return firstPayTime(_this.searchInfo);
            case 4:
              res = _context.sent;
              if (!res.data.list || res.data.list.length == 0) {
                _this.tableData = [];
                _this.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this.tableData = res.data.list;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};